import { render, staticRenderFns } from "./quick-add-member-picker.vue?vue&type=template&id=47980e60&"
import script from "./quick-add-member-picker.vue?vue&type=script&lang=ts&"
export * from "./quick-add-member-picker.vue?vue&type=script&lang=ts&"
import style0 from "./quick-add-member-picker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports